import './styles/style.scss';
import Section from './Section';

export default Section;
export { propTypes as SectionPropTypes } from './Section';



// WEBPACK FOOTER //
// ./src/components/Section/index.js